import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { FormatPipe } from '@app/pipes/format.pipe';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';

@Component({
  selector: 'afcu-title',
  standalone: true,
  imports: [],
  templateUrl: './title.component.html'
})
export class TitleComponent extends BaseConfigurableComponent{

  private formatPipe = inject(FormatPipe)
  private schedulerService = inject( SchedulerStepService );

  constructor (private router: Router) {
    super('title')
    this.getOrigin()
  }

  get title () {
  const appointmentGreeting = this.getText().yourAppointment[(this.origin === 'queue') ? 'queue' : 'checkIn'];

    if (this.router.url === '/branches-location')
      return this.getText().branch
    else if (this.router.url.includes('/check-in'))
      return this.getText().checkIn
    else if (this.router.url.includes('/your-appointment')){
      return (this.origin === 'queue') ? this.formatPipe.transform(appointmentGreeting, {'firstname': this.schedulerService.payload()['contact-info'].fullName.split(' ')[0]}) : (this.origin === 'check-in') ? this.formatPipe.transform(appointmentGreeting, {'firstname': this.schedulerService.payload()['contact-info'].fullName.split(' ')[0]})  : this.getText().yourAppointment.original
    }else if (this.router.url.includes('/configuration')){
      return 'Kiosk Configuration'
    }else{
      return this.getText()['service'][this.schedulerService.actualStep()]
    }
      
  }
}
